export const NOTIFICATION_RECEIVED = 'NOTIFICATION/RECEIVED';
export const NOTIFICATION_REMOVED = 'NOTIFICATION/REMOVED';
export const NOTIFICATION_SUBSCRIBE = 'NOTIFICATION/SUBSCRIBE';

export const NEW_VERSION_AVAILABLE = 'SW/VERSION_AVAILABLE';
export const UPDATE_SERVICE_WORKER = 'SW/UPDATE';
export const UPDATE_SERVICE_WORKER_SUCCESS = 'SW/UPDATE_SUCCESS';
export const UPDATE_SERVICE_WORKER_ERROR = 'SW/UPDATE_ERROR';
